import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
	ITermsAndConditionsCheckboxProps,
	TermsAndConditionsCheckbox,
} from './TermsAndConditionsCheckbox';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { StyledTextFieldErrorMessage } from '../../../../ui';

export const TermsAndConditions = (
	props: Partial<ITermsAndConditionsCheckboxProps>,
) => {
	const { t } = useTranslation();

	const {
		register,
		trigger,
		watch,
		formState: { errors },
	} = useFormContext();
	const isChecked = watch('termsAndConditions');

	return (
		<>
			<TermsAndConditionsCheckbox
				invalid={!!errors.termsAndConditions}
				{...props}
				{...register('termsAndConditions', {
					onChange: () => {
						trigger('termsAndConditions');
					},
				})}
			/>
			{!!errors.termsAndConditions && !isChecked && (
				<StyledTextFieldErrorMessage role="alert">
					{t('parking_booking_error_terms_and_conditions')}
				</StyledTextFieldErrorMessage>
			)}
		</>
	);
};
